import { formatCurrency } from 'utils/formatNumber';
import clsx from 'clsx';
import {
  AgxRow,
  AgxColumn,
  AgxBodyText,
  AgxCaption,
  Images,
} from '@urbanx/agx-ui-components';
import { Breakpoints, ScreenSize } from 'utils/screen';
import { ComparablePropertyModel } from 'store/cmaPropertySearch/types';
import defaultImage from './assets/icons/house-placeholder.png';
import { CircularSelector } from './CircularSelector';
import './CMAPropertyImageCard.scss';

interface CMAPropertyImageCardProps {
  property: ComparablePropertyModel;
  timeAgo: string;
  onPropertyImageCheck: (property: ComparablePropertyModel) => void;
  selectedCmaProperty: ComparablePropertyModel[];
}

export const CMAPropertyImageCard = ({
  property,
  timeAgo,
  onPropertyImageCheck,
  selectedCmaProperty,
}: CMAPropertyImageCardProps) => {
  const isSelected = selectedCmaProperty.some(
    selectedProperty => selectedProperty.propertyId === property.propertyId
  );

  const cardClasses = clsx('agxPropertyCard', isSelected && 'selected');

  const wrapperClickEvent =
    ScreenSize() === Breakpoints.Desktop
      ? () => onPropertyImageCheck(property)
      : undefined;

  return (
    <div
      className={cardClasses}
      data-testid={property.propertyId}
      onClick={wrapperClickEvent}
    >
      <div
        className="propertyImageWrapper"
        style={{
          backgroundImage: `url('${property.thumbnailUrl ?? defaultImage}')`,
        }}
      ></div>
      <AgxColumn smallGap fill spaceBetween>
        <AgxBodyText small>{property.address}</AgxBodyText>
        <AgxRow mediumGap centered>
          <AgxRow smallGap centered>
            <Images.Bed />
            <AgxCaption small>{property.bedrooms}</AgxCaption>
          </AgxRow>
          <AgxRow smallGap centered>
            <Images.Bath />
            <AgxCaption small>{property.bathrooms}</AgxCaption>
          </AgxRow>
          <AgxRow smallGap centered>
            <Images.Car />
            <AgxCaption small>{property.carSpaces}</AgxCaption>
          </AgxRow>
          <AgxRow smallGap centered>
            <Images.Area />
            <AgxCaption small>{property.landArea}m²</AgxCaption>
          </AgxRow>
        </AgxRow>
        <AgxRow largeGap>
          <AgxBodyText small>{formatCurrency(property.price, 0)}</AgxBodyText>
          <AgxBodyText small>{timeAgo}</AgxBodyText>
          <AgxBodyText small>
            {property.distanceFromProperty}km
            <span className="cmaDistancePrepend"> away</span>
          </AgxBodyText>
        </AgxRow>
      </AgxColumn>

      <AgxColumn centered centerJustified>
        <CircularSelector
          onClicked={() => onPropertyImageCheck(property)}
          selected={isSelected}
        />
      </AgxColumn>
    </div>
  );
};
